<template>
	<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">
		<div class="sf-card__content">
			<el-row :gutter="20">
				<el-col :span="8">
					<sf-input-group :label="getMessage_('MWCC000420')" :labelSpan="10" labelPosition="left" :inputValue="param.partsNo" readonly />
				</el-col>
				<el-col :span="8">
					<sf-input-group :label="getMessage_('MWCC000462')" :labelSpan="10" labelPosition="left" :inputValue="param.partsName" />
				</el-col>
				<el-col :span="8">
					<sf-input-group :label="getMessage_('MWCC000464')" :labelSpan="10" labelPosition="left" :inputValue="param.partsEnName" />
				</el-col>
			</el-row>
		</div>
		<!--탭-->
		<!-- <el-tabs type="border-card" class="h-500 no-scroll">
			<el-tab-pane class="mt-2" v-for="(menu, index) in menuList" :key="index" :label="menu.name">
				<component :is="menu.tag" class="px-3 pb-2" :scrId="scrId"></component>
			</el-tab-pane>
		</el-tabs> -->

		<template v-slot:footer>
			<sf-button line :onClick="close">{{ getMessage_('MWCC000343') }}</sf-button>
			<sf-button :onClick="openModal">modal</sf-button>
		</template>
		<popup-view-two ref="popupView2" :popup2="popup2" />
	</sf-modal-layout>
</template>

<script>
import PopupViewTwo from './PopupViewTwo.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/PartsInfo/store/helpers';
import GridView from '@qms/PartsInfo/Content/Popup/TableInner/GridView.vue';
import SecondGridView from '@qms/PartsInfo/Content/Popup/TableInner/SecondGridView.vue';
export default {
	props: { isOpen: { type: Boolean, default: false } },
	components: {
		PopupViewTwo
		//,
		//		GridView,
		//		SecondGridView
	},
	data() {
		return {
			show: this.isOpen,
			param: '',
			popup2: false
			// ,
			// menuList: [
			// 	{ tag: 'grid-view', name: 'grid view' },
			// 	{ tag: 'second-grid-view', name: 'second grid view' }
			// ]
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('QWCC000915');
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;
			this.param = param;
		},
		close() {
			this.show = false;
		},
		openModal() {
			this.popup2 = true;
			this.$refs.popupView2.open();
		}
	}
};
</script>

<style scoped>
.user-managment-items-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
